import React from 'react';
import { useActivation } from '@context/MobileOne';
import {
  ButtonCheckbox,
  ButtonPrimary,
  CardSupport,
  FormInputField,
  Link,
  ApiError,
  Ta11yText,
  ScrollToTop,
  ButtonCancelActivation,
  FocusFirstError
} from '@core/index';
import AppPageContentWrapper from '@part/AppPageContentWrapper';
import { tA11y } from '@utils/a11y/a11yHelpers';
import {
  appAlert,
  appButtonType,
  appCardStyle,
  appCheckboxSize,
  appIconsPath,
} from '@utils/globalConstant';
import { Form, Formik } from 'formik';
import { useA11y } from '@context/Utils';
import Icons from '@core/Utils/Icons/Icons';

export function VoucherActivation() {
  // Contexts
  const {
    isLoading,
    setShowActivationHeader,
    withVoucher,
    setWithVoucher,
    setStep4SubStep,
    voucherGBNo,
    voucherDataValidations,
    checkVoucherCode,
    voucherCodeError,
    setVoucherCodeError
  } = useActivation();
  const { isGenericApiError } = useA11y();

  // const
  const headerContent = tA11y('ek_reg_voucher_hdl1');
  const checkboxLabelContent = tA11y('ek_reg_voucher_chckbx_txt1');
  const buttonContent = tA11y('ek_reg_voucher_btn1');
  const voucherbtnContent = tA11y('ek_reg_voucher_btn2');

  const handleAPIErrorLink = () => {
    const firstInput = document.querySelector('#voucherCode');
    if (firstInput) {
      firstInput.focus();
    }
  }

  return (
    <>
      <ScrollToTop>
        <div className="min-dvh-100 voucher-code-container">
          <AppPageContentWrapper>
            <div className="w-100 d-flex justify-content-center">
              <Icons name="PERCENTAGE" width={66} height={66} colorType='dark' />
            </div>
            <Ta11yText tag="h2" className="pt-40 text-primary" textContent={headerContent} />
            <div className="pt-40 w-100 text-primary">
              <ButtonCheckbox
                checkboxContent={checkboxLabelContent}
                checkboxSize={appCheckboxSize.LARGE}
                id="voucher"
                value={withVoucher}
                onChange={(e) => {
                  setWithVoucher(e);
                }}
              />
            </div>
            {withVoucher ? (
              <div className="form-container pt-40">
                <Formik
                  initialValues={{ voucherCode: '' }}
                  validationSchema={voucherDataValidations}
                  onSubmit={({ voucherCode }) => {
                    checkVoucherCode(voucherCode);
                    document?.querySelector('#voucherCode')?.focus()
                  }}>
                  {({
                    values: { voucherCode },
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    touched,
                    errors,
                    setFieldValue
                  }) => {
                    // console.log(errors);
                    return (
                      <Form onSubmit={handleSubmit}>
                        <FormInputField
                          label="ek_global_voucher_code_lbl"
                          placeholder="ek_global_voucher_code_plc"
                          type="text"
                          id="voucherCode"
                          name="voucherCode"
                          value={voucherCode}
                          onChange={(e) => {
                            handleChange({
                              target: {
                                id: 'voucherCode',
                                name: 'voucherCode',
                                value: e.target.value
                              }
                            });
                            setVoucherCodeError(null);
                          }}
                          onClear={() => {
                            setFieldValue('voucherCode', '');
                            setVoucherCodeError(null);
                          }}
                          onBlur={handleBlur}
                          valid={touched.voucherCode && !errors.voucherCode}
                          invalid={touched.voucherCode && errors.voucherCode || !!(voucherCodeError && !isGenericApiError)}
                          invalidMessage={
                            touched.voucherCode && errors.voucherCode ? errors.voucherCode : null
                          }
                          aria-describedby="voucherCode-error"
                        />
                        {voucherCodeError && (
                          <div className="form-text mt-40 ps-4" aria-live="polite">
                            <ApiError message={voucherCodeError} isGenericApiError={isGenericApiError} handleAPIErrorLink={handleAPIErrorLink}/>
                          </div>
                        )}
                        <div className="w-100">
                          <div className="col-xxl-5 col-lg-5 col-10 px-0 mx-auto">
                            <ButtonPrimary
                              buttonClass="mt-40"
                              buttonType={appButtonType.PRIMARY}
                              buttonContent={voucherbtnContent}
                              type="submit"
                              isLoading={isLoading}
                            />
                          </div>
                        </div>
                        <FocusFirstError/>
                      </Form>
                    );
                  }}
                </Formik>
              </div>
            ) : (
              <div className="w-100">
                <div className="col-xxl-5 col-lg-5 col-10 px-0 mx-auto">
                  <ButtonPrimary
                    buttonClass="mt-40"
                    buttonType={appButtonType.PRIMARY}
                    buttonContent={buttonContent}
                    onClick={() => {
                      setStep4SubStep(1);
                      setShowActivationHeader(false);
                    }}
                  />
                </div>
              </div>
            )}

            <div className="space-40"></div>
            <CardSupport />
            <div className="d-flex justify-content-center mt-32">
              <ButtonCancelActivation />
            </div>
          </AppPageContentWrapper>
        </div>
      </ScrollToTop>
    </>
  );
}

export default VoucherActivation;
